import React, { useContext, useEffect, useState } from "react";
import { DashboardWrapper } from "./style";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import c1icon from "../../images/c1.png";
import c2icon from "../../images/c2.png";
import c3icon from "../../images/c3.png";
import c4icon from "../../images/c4.png";
import c5icon from "../../images/c5.png";
import banner from "../../images/bannerimg2.png";
import play from "../../images/play-circle.png";
import Button from "../../components/ui/Button";
import { useNavigate } from "react-router-dom";
import { getStorage, setStorage } from "../../Utils/common";
import ContextDashboard from "../../Context/ContextDashboard";
import DashboardCard2 from "./DashboardCard2";
import { getDashboardData, ckeckEligibility } from "../../Utils/api";
import Modal from "../../components/Modal/Modal";

const cardList = [
  {
    heading: "PAN Authentication",
    desc: "Please enter your PAN Card number. Your identity is secure with us.",
    img: c1icon,
    link: "/my-dashboard/pan-details"
  },
  {
    heading: "Personal Information",
    desc: "Share with us a bit about yourself.",
    img: c3icon,
    link: "/my-dashboard/captur-personal-information"
  },
  {
    heading: "Current Residence Address",
    desc: "Ensure to provide correct residence address. No Surprise Visits, We Promise.",
    img: c2icon,
    link: "/my-dashboard/captur-address"
  },
  {
    heading: "Income Details",
    desc: "Share your Income Details.",
    img: c4icon,
    link: "/my-dashboard/captur-income-details"
  },
  {
    heading: "Selfie Upload",
    desc: "Share your selfie and complete the registration.",
    img: c5icon,
    link: "/my-dashboard/upload-picture"
  },
];

function DashBoard() {
  const [cards, setCards] = useState(cardList);
  const [stepComplate, setStepComplate] = useState(false);
  const [showSteps, setShowSteps] = useState(0);
  const [toggle, setToggle] = useState(true);
  const [progressBar, setProgressBar] = useState(0);
  const [modelOpen, setModelOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [responce, setResponce] = useState(false);
  const [status, setStatus] = useState();
  const [registrationSuccessful, setRegistrationSuccessful] = useState(false); // New state to track registration success
  const [isApplicationSubmitted, setIsApplicationSubmitted] = useState(false);
  const [leadId, setLeadId] = useState("");
  const { message, setMessage, setProfileData, profileData, eligibilityStatus, getProfileDaital, logout, currentEvent } = useContext(ContextDashboard);

  const navigate = useNavigate();

  const redirect = (data) => {
    navigate(data.link);
  };

  const showSteps_ = () => {
    if (eligibilityStatus === 'ELIGIBLE') {
      navigate('/my-dashboard/eligibility');
    } else {
      setToggle(!toggle);
    }
  };

  const submit = async () => {
    const param = {
      "profile_id": getStorage("cust_profile_id") || "",
      "event_name": "register_now",
    };

    setLoading(true);

    ckeckEligibility(param).then((resp) => {
      setLoading(false);
      if (resp?.data?.Status === 1) {
        setModelOpen(true);
        setStorage("next_step", resp?.data?.Data?.next_step);
        setStorage("eligibility", 1);
        setResponce(resp?.data?.Message);
        setStatus(resp?.data?.Status);
      } else if (resp?.data?.Status === 4) {
        logout();
      } else {
        setModelOpen(true);
        setResponce(resp?.data?.Message);
        setStatus(resp?.data?.Status);
      }
    });
  };

  useEffect(() => {
    // First check if application is already submitted from storage
    const storedApplicationStatus = getStorage("application_status");
    const storedLeadId = getStorage("lead_id");
    
    if (storedApplicationStatus === "submitted") {
      console.log("Application already submitted from storage - setting frozen state");
      setIsApplicationSubmitted(true);
      setLeadId(storedLeadId);
    }

    const params = {
      profile_id: getStorage("cust_profile_id") || "",
    };

    getDashboardData(params).then(resp => {
      if (resp?.data?.Status === 1) {
        const dashboardData = resp?.data || {};
        setStorage('dashboardData', dashboardData);
        setStorage('step_percent', dashboardData?.Data?.profile_filled_percent);
        setProgressBar(dashboardData?.Data?.profile_filled_percent);
        
        // Check if registration is successful
        if (dashboardData?.Data?.registration_successful === 1) {
          setRegistrationSuccessful(true); // Set to true if registration is successful
        } else {
          setRegistrationSuccessful(false); // Set to false if registration is not successful
        }

        // Check if application is already submitted
        const profileData = dashboardData?.Data?.profile_details;
        const applicationStatus = profileData?.application_submitted;
        const leadId = profileData?.lead_id;
        
        console.log("=== APPLICATION STATUS CHECK ===");
        console.log("Profile Data:", profileData);
        console.log("Application Status:", applicationStatus);
        console.log("Lead ID:", leadId);
        console.log("Current isApplicationSubmitted:", isApplicationSubmitted);
        
        if (applicationStatus === 1 || applicationStatus === "1") {
          console.log("Application is submitted - setting frozen state");
          setIsApplicationSubmitted(true);
          setLeadId(leadId);
          setStorage("lead_id", leadId);
          setStorage("application_status", "submitted");
        } else {
          console.log("Application is not submitted - allowing normal flow");
        }
      }
    });
  }, []);

  useEffect(() => {
    const nextStep = getStorage("next_step");
    console.log("nextStep from storage:", nextStep);
    if (nextStep) {
      const steps = currentEvent(nextStep);
      console.log("calculated steps:", steps);
      setShowSteps(steps);
    } else {
      // If no next_step is stored, default to first step (PAN Authentication)
      console.log("No next_step found, defaulting to 0");
      setShowSteps(0);
    }
  }, []);

  return (
    <DashboardWrapper>
      <div style={{ paddingTop: '1px' }}>
        <ProgressBar value={`${progressBar}%`}>
          {registrationSuccessful && ( // Only show button if registration is successful
            <div>
              <Button title="Check Eligibility" onClick={submit} loading={loading} />
            </div>
          )}
        </ProgressBar>
      </div>

      {/* Application Submitted - Frozen State */}
      {isApplicationSubmitted && (
        <div style={{
          backgroundColor: '#f8f9fa',
          border: '2px solid #28a745',
          borderRadius: '10px',
          padding: '30px',
          margin: '20px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '60px', color: '#28a745', marginBottom: '20px' }}>
            ✅
          </div>
          <h2 style={{ color: '#28a745', marginBottom: '15px' }}>
            Application Already Submitted!
          </h2>
          {leadId && (
            <div style={{
              backgroundColor: '#e7f3ff',
              border: '1px solid #b3d9ff',
              borderRadius: '8px',
              padding: '15px',
              margin: '15px 0',
              display: 'inline-block'
            }}>
              <strong>Your Application ID: {leadId}</strong>
            </div>
          )}
          <p style={{ color: '#666', fontSize: '16px', margin: '15px 0' }}>
            Your application is currently under review. Our teammate will contact you soon.
          </p>
          <p style={{ color: '#888', fontSize: '14px', margin: '10px 0' }}>
            You cannot re-apply until your current application status is closed.
          </p>
        </div>
      )}

      {!isApplicationSubmitted && toggle ? (
        <div className="carde">
          {cards.map((value, index) => {
            const isCompleted = (index + 1) <= showSteps;
            const isCurrentStep = index === showSteps;
            const isDisabled = !isCurrentStep && !isCompleted;
            
            console.log(`Card ${index + 1}:`, {
              heading: value.heading,
              isCompleted,
              isCurrentStep,
              isDisabled,
              showSteps
            });
            
            return (
              <DashboardCard2
                number={index + 1}  // Adding the card number
                heading={value.heading}
                desc={value.desc}
                img={value.img}
                complate={isCompleted}
                disable={isDisabled}
                key={index}
                onClick={() => !isDisabled && redirect(value)}
              />
            );
          })}
          <div className="hideMD"></div>
        </div>
      ) : null}

      {!isApplicationSubmitted && !toggle ? (
        <>
          <div className="banner flex">
            <div className="card card1">
              <h2>Your Gateway to Quick Easy & Hassle Free Finances.</h2>
            </div>
            <div className="card card2">
              <img src={banner} alt="" />
              <div className="center play">
                <img src={play} alt="play" />
                <h2>JOURNEY STEPS</h2>
              </div>
            </div>
            <div className="card card3">
              <h3>Dive into Financial Freedom!</h3>
              <p>Apply now for our instant personal loan - unlock a world of collateral-free ease, no credit score hassles, a seamless 100% online application process, and the simplicity of minimal documentation. Your journey to hassle-free finances starts here!.</p>
              <Button title="Support" />
            </div>
          </div>
        </>
      ) : null}
      {modelOpen && <Modal onClose={() => setModelOpen(false)} msg={responce} state={status} onConfirm={() => navigate("/my-dashboard/eligibility")} />}
    </DashboardWrapper>
  );
}

export default DashBoard;
